import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'nsp-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {}
